import { render, staticRenderFns } from "./CancelBooking.vue?vue&type=template&id=67e55d6c&scoped=true&"
import script from "./CancelBooking.vue?vue&type=script&lang=ts&"
export * from "./CancelBooking.vue?vue&type=script&lang=ts&"
import style0 from "./CancelBooking.vue?vue&type=style&index=0&id=67e55d6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e55d6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VContainer,VDialog,VImg,VOverlay,VProgressCircular})
